import { Collapse } from '@mui/material';
import { FileWithPreview } from 'js/components/data_sources/add_ds_form/FileUploadConfiguration/FileUploadConfiguration.types';
import { Tabs } from 'new/elements/Tabs';
import React from 'react';
import EnterCustomProcessor from './EnterCustomProcessor';
import classes from './FileDataFormatSection.module.scss';
import { LoadCustomProcessor } from 'new/components/flows/shared/customProcessor';
import SaveCustomProcessor from './SaveCustomProcessor';
import TestCustomProcessor from './TestCustomProcessor';

interface TabComponentProps {
  sourceConfig: any;
  onSourceConfigChanged: (config: any) => void;
  isFlexFlow?: boolean;
}

const tabs = [
  {
    label: 'Use Existing Function',
    value: 'reusable_code_container',
    Component: LoadCustomProcessor as React.ComponentType<TabComponentProps>,
  },
  {
    label: 'Provide Your Own Function',
    value: 'custom_code',
    Component: EnterCustomProcessor as React.ComponentType<TabComponentProps>,
  },
];

interface FileDataFormatSectionProps {
  section: string;
  fields: any[];
  sourceConfig: any;
  buildSourceInfo: any;
  onSourceConfigChanged: (config: any) => void;
  getProbeSampleCallback: any;
  useFlexFlowCustomSourceConfig: any;
  getCustomProcessorId: any;
  uploadedFiles?: FileWithPreview[];
}

const FileDataFormatSection: React.FC<FileDataFormatSectionProps> = ({
  section,
  fields,
  sourceConfig,
  buildSourceInfo,
  onSourceConfigChanged,
  getProbeSampleCallback,
  useFlexFlowCustomSourceConfig,
  getCustomProcessorId,
  uploadedFiles,
}) => {
  if (section !== 'Define Processing Logic') {
    return fields;
  }

  const selectedTab = sourceConfig?.['ui.custom_processor_mode'] || tabs[0].value;

  const TabComponent = tabs.find(({ value }) => value === selectedTab)?.Component;

  if (!TabComponent) {
    return fields;
  }

  const onTabChanged = (event, value) => {
    const updatedConfig = {
      ...sourceConfig,
      'ui.custom_processor_mode': value,
    };

    if (
      sourceConfig?.['ui.custom_processor_mode'] === 'custom_code' &&
      value === 'reusable_code_container'
    ) {
      delete updatedConfig.customProcessorCode;
    }

    onSourceConfigChanged(updatedConfig);
  };

  const additionalElements = (
    <Collapse key="FileDataFormatSection" in={!!sourceConfig?.['ui.use_custom_processor']}>
      <div className={classes.root} data-testid="FileDataFormatSection">
        <div className={classes.tabsContainer}>
          <Tabs value={selectedTab} tabs={tabs} onChange={onTabChanged} />
          {selectedTab === 'custom_code' && <SaveCustomProcessor sourceConfig={sourceConfig} />}
        </div>
        <div className={classes.tabComponentContainer}>
          <TabComponent
            sourceConfig={sourceConfig}
            onSourceConfigChanged={onSourceConfigChanged}
            isFlexFlow={Boolean(useFlexFlowCustomSourceConfig)}
          />
        </div>
        <TestCustomProcessor
          sourceConfig={sourceConfig}
          buildSourceInfo={buildSourceInfo}
          getProbeSampleCallback={getProbeSampleCallback}
          getCustomProcessorId={getCustomProcessorId}
          useFlexFlowCustomSourceConfig={useFlexFlowCustomSourceConfig}
          uploadedFiles={uploadedFiles}
        />
      </div>
    </Collapse>
  );

  return [...fields, additionalElements];
};

export default FileDataFormatSection;
